module.exports = __webpack_public_path__ + "img/7安全管理体系认证证书.17a7628b.jpg";